/**
 * @packageDocumentation
 * @module f1/array
 */

import initial from './initial';
import last from './last';
import tail from './tail';
import head from './head';

/** @ignore */
type t_seg<T> = [T[], T[]];

export interface Segment {
  /**
   * Segments by one of two array slicing rules (initial/last or head/tail)
   *
   * @public
   * @function f1.segment
   * @param rule the segmentation rule
   * @param arr the list to slice
   * @example
   *
   * ```ts
   * segment('initial/last', [1, 2, 3, 4]) => [[1, 2, 3], [4]]
   * segment('head/tail', [1, 2, 3, 4]) => [[1], [2, 3, 4]]
   * ```
   *
   */
  <T>(rule: 'initial/last' | 'head/tail', arr: T[]): t_seg<T>;
  <T>(rule: 'initial/last' | 'head/tail'): (arr: T[]) => t_seg<T>;
}

/**
 * @see Segment
 */
export default <T>(rule: 'initial/last' | 'head/tail', arr: T[]): t_seg<T> => {
  return rule === 'initial/last' ? [initial(arr), last(arr)] : [head(arr), tail(arr)];
};
